import React, { useEffect, useContext } from "react";
import "../../style.css";
import "../../animate.css";
import "../../icomoon.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { educationData } from "../../data/educationData"; // Importer les données
import { LanguageContext } from "../../contexts/LanguageContext"; // Importer le contexte
import { experienceData } from "../../data/experienceData";

function EducationTest() {
  const { language } = useContext(LanguageContext); // Récupérer la langue du contexte

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const isMobile = window.innerWidth <= 600;

    const animateElements = (selector, fromX) => {
      document.querySelectorAll(selector).forEach((element) => {
        gsap.fromTo(
          element,
          {
            x: fromX,
            opacity: 0,
          },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            scrollTrigger: {
              trigger: element,
              start: "bottom bottom",
              end: "bottom top",
            },
          }
        );
      });
    };

    if (isMobile) {
      // Tous les éléments viennent de la droite
      animateElements(".timeline-inverted", 100);
      animateElements(".timeline-unverted", 100);
    } else {
      // Comme avant : inversés selon la classe
      animateElements(".timeline-inverted", 100);
      animateElements(".timeline-unverted", -100);
    }
  }, []);

  return (
    <div id="education" className="fh5co-bg-color">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-md-offset-0">
            <ul className="timeline">
              <br />
              <li
                className="timeline-heading text-center animate-box d-flex justify-content-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <div className="d-flex justify-content-center">
                  <h3>{language === "en" ? "Expercience" : "Expérience"}</h3>{" "}
                  {/* Dynamique selon la langue */}
                </div>
              </li>
              {experienceData.map((experience) => (
                <li
                  key={experience.id}
                  className={`timeline-${
                    experience.id % 2 === 0 ? "unverted" : "inverted"
                  } animate-box`}
                >
                  <div className="timeline-badge timeline-badge-company">
                    {/* <i className="icon-graduation-cap"></i> */}
                    <img src={experience.logo} alt="none" />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h3 className="timeline-title">
                        {experience.jobtitle[language]}
                      </h3>{" "}
                      {/* Affiche selon la langue */}
                      <span className="company">
                        {experience.company} | {experience.startYear} - { experience.endYear}
                      </span>
                    </div>
                    <div className="timeline-body">
                      <p>{experience.jobDesc[language]}</p>{" "}
                      {/* Affiche selon la langue */}
                    </div>
                  </div>
                </li>
              ))}
              <br />
              <li
                className="timeline-heading text-center animate-box d-flex justify-content-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <div className="d-flex justify-content-center">
                  <h3>{language === "en" ? "Education" : "Éducation"}</h3>{" "}
                  {/* Dynamique selon la langue */}
                </div>
              </li>

              {/* Boucle pour afficher toutes les données d'éducation */}
              {educationData.map((education) => (
                <li
                  key={education.id}
                  className={`timeline-${
                    education.id % 2 === 0 ? "unverted" : "inverted"
                  } animate-box`}
                >
                  <div className="timeline-badge">
                    <i className="icon-graduation-cap"></i>
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h3 className="timeline-title">
                        {education.title[language]}
                      </h3>{" "}
                      {/* Affiche selon la langue */}
                      <span className="company">
                        {education.institution[language]} | {education.period}
                      </span>
                    </div>
                    <div className="timeline-body">
                      <p>{education.description[language]}</p>{" "}
                      {/* Affiche selon la langue */}
                    </div>
                  </div>
                </li>
              ))}

              
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EducationTest;
